<template>
    <div>
      <v-row>
        <v-col cols="12" sm="4" md="4">
          <v-card class="height-card">
            <v-card-title>
              Plan Corporativo
            </v-card-title>
            <v-card-text>
              Número de Cuenta: {{ dealerAccount.account_number }}
            </v-card-text>
            <v-card-text>
              Folios disponibles:
              <span v-if="dealerAccount.folios > 0" :class="themeColor" class="label">{{ dealerAccount.folios }}</span>
              <span v-else :class="themeColor" class="label">{{ dealerAccount.folios }}</span>
            </v-card-text>
            <v-card-text>
              <v-btn
                :color="themeColor"
                class="label"
                @click="goToDealerAccount"
              >
                Ir a mi cuenta
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-card class="height-card">
            <v-card-title>
              Empresas
            </v-card-title>
            <v-card-text>
              FEL: <span :class="themeColor" class="label">{{ totalFEL }}</span>
            </v-card-text>
            <v-card-text>
              PAC: <span :class="themeColor" class="label">{{ totalPAC }}</span>
            </v-card-text>
            <v-card-text>
              <v-btn
                :color="themeColor"
                class="label"
                @click="goToEnterprises"
              >
                Ir a Empresas
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-card class="height-card">
            <v-card-title>
              Licencias de Servicios
            </v-card-title>
            <v-card-text>
              FEL: <span :class="themeColor" class="label">{{ totalLicencesFEL }}</span>
            </v-card-text>
            <v-card-text>
              PAC: <span :class="themeColor" class="label">{{ totalLicencesPAC }}</span>
            </v-card-text>
            <v-card-text>
              <v-btn
                class="label"
                :color="themeColor"
                @click="goToServices"
              >
                Ir a mis Servicios
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog
        v-model="notifyModal"
        max-width="480"
      >
        <v-card>
          <v-card-title class="headline">
            Notificaciones pendientes
          </v-card-title>
          <v-card-text>
            Tienes {{ notifyCount }} {{ $t('notification') }} por revisar.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click.prevent="goToNotifications"
            >
              Ver notificaciones
            </v-btn>
            <v-btn
              text
              @click="notifyModal = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

  <script>
  import { mapGetters } from 'vuex';

  export default {
    middleware: 'auth',

    metaInfo() {
      return { title: 'Inicio' };
    },
    data: () => ({
      dealerAccount: {},
      totalFEL: 0,
      totalPAC: 0,
      totalFELPAC: 0,
      totalLicencesFEL: 0,
      totalLicencesPAC: 0,
      notifyModal: false,
      notifyCount: 0,
      notifyCountURL: 'api/notification/getNotificationCount?type_portal=DISTRIBUIDOR',
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user',
        themeColor: 'theme/themeColor',
      }),
    },
    async mounted() {
      await this.getDealerAccount();
      await this.getDealerEnterprises();
      this.loadNotifyCount();
    },
    methods: {
      loadNotifyCount() {
        window.axios.get(`${this.notifyCountURL}`)
          .then((response) => {
            const count = Number(response.data) || 0;
            this.notifyCount = count;
            this.$store.dispatch('sidebar/setSidebarCountNotify', { value: count });
            if (count > 0 && !sessionStorage.getItem('notify_modal_shown')) {
              this.notifyModal = true;
              sessionStorage.setItem('notify_modal_shown', '1');
            }
          });
      },
      goToNotifications() {
        this.notifyModal = false;
        if (this.$route.name !== 'notification') {
          this.$router.push({ name: 'notification' });
        }
      },
      getDealerAccount() {
        const url = 'api/account';
        window.axios.get(url)
          .then((response) => {
            response.data.items.forEach((item) => {
              this.dealerAccount = item;
            });
          });
      },
      getDealerEnterprises() {
        const url = `/api/catalogs/dealers/${this.user.dealer_id}/getIndicators`;
        window.axios.get(url)
          .then((response) => {
            if (response.data.code === 200) {
              response.data.total_enterprises.forEach((typeEnterprises) => {
                if (typeEnterprises.type === 1) {
                  this.totalFEL = typeEnterprises.count_type;
                } else if (typeEnterprises.type === 3) {
                  this.totalPAC = typeEnterprises.count_type;
                }
              });
              response.data.total_licences.forEach((typeLicence) => {
                if (typeLicence.servicio === 'PAC') {
                  this.totalLicencesPAC = typeLicence.disponibles;
                } else if (typeLicence.servicio === 'FEL') {
                  this.totalLicencesFEL = typeLicence.disponibles;
                }
              });
            }
          });
      },
      goToDealerAccount() {
        this.$router.push({ path: '/planes-corporativos/cuentas' });
      },
      goToEnterprises() {
        this.$router.push({ path: '/empresas' });
      },
      goToServices() {
        this.$router.push({ path: '/catalogos/servicios' });
      },
    },
  };
  </script>

  <style scoped>
    .label {
      color:white;
      padding: 4px;
      border-radius: 5px;
    }
    .height-card {
      height: 250px !important;
    }
  </style>
